import React from 'react';
import Kyc from './Kyc';

// Profile Setup contains all vendor-editable profile and contact sections.
const profileTabs = ['accountInfo', 'media', 'categories', 'info', 'whatsapp', 'email', 'social', 'about'];

const ProfileSetup = () => {
  return <Kyc filterTabs={profileTabs} />;
};

export default ProfileSetup;
